import { Post, PostJson } from "../core/Helper";

export class NotifyMessageService {
  static async GetUserMessage(params) {
    let result = await Post("api/notify-message/get-user-messages", params);
    return result ?? null;
  }
  static async RemoveUserMessage(params) {
    let result = await Post("api/notify-message/remove-user-messages", params);
    return result ?? null;
  }
  static async GetUserMessageCounted(params) {
    let result = await Post("api/notify-message/remove-user-messages", params);
    return result ?? null;
  }

  static async RemoveALLUserMessage(params) {
    let result = await Post(
      "api/notify-message/remove-all-user-messages",
      params
    );
    return result ?? null;
  }
}
